{
  "el": {
    "signature": {
      "actions": {
        "clearSignature": "Εκκαθάριση υπογραφής",
        "edit": "Επεξεργασία",
        "request": "Αίτηση υπογραφής",
        "save": "Αποθήκευση",
        "sign": "Υπογραφή"
      },
      "labels": {
        "add": "Προσθήκη",
        "add_customer_signatures": "Πρέπει να προσθέσεις υπογραφές πελατών πριν από την αποθήκευση.",
        "add_team_member_signatures": "Πρέπει να προσθέσεις υπογραφές για τα μέλη της ομάδας πριν από την αποθήκευση.",
        "all_customers_signed": "Όλοι οι πελάτες που χρειαζόταν να υπογράψουν έχουν ήδη υπογράψει. Τα έγγραφα πρέπει ακόμα να υπογραφούν από εκπροσώπους της εταιρείας «{client_name}» και η πρόταση θα εγκριθεί μόλις τα υπογράψουν εκείνοι. Δεν απαιτείται καμία περαιτέρω ενέργεια από την πλευρά σου.",
        "browserNotSupported": "Εντοπίσαμε ότι το πρόγραμμα περιήγησης του κινητού σου ενδέχεται να μην υποστηρίζει ηλεκτρονικές υπογραφές. Αν αντιμετωπίσεις προβλήματα, άλλαξε πρόγραμμα περιήγησης ή συσκευή, ή ανέβασε ένα υπογεγραμμένο έγγραφο.",
        "customer_signatories": "Υπογράφοντες πελάτες",
        "customers_left_to_sign": "1 πελάτης πρέπει να υπογράψει | {customers_left_to_sign} πελάτες πρέπει να υπογράψουν",
        "customers_required_to_sign": "Ακόμα 1 πελάτης πρέπει να υπογράψει τα έγγραφα. | Ακόμα {customers_left_to_sign} πελάτες πρέπει να υπογράψουν τα έγγραφα.",
        "customers_signed_names": "Πελάτες που έχουν ήδη υπογράψει: {names}",
        "document_image_data_error": "Η φόρτωση των δεδομένων εικόνας του εγγράφου απέτυχε.",
        "document_load_error": "Δεν ήταν δυνατή η φόρτωση του εγγράφου. Έλεγξε αν το αρχείο είναι έγκυρο.",
        "document_url_missing_error": "Λείπει το URL του εγγράφου.",
        "documents_to_sign": "Έγγραφα προς υπογραφή",
        "draw_signature": "Σχεδίασε την υπογραφή σου παρακάτω",
        "employee_signatories": "Υπογράφοντες της εταιρείας «{client_name}»",
        "employees_signed_names": "Μέλη ομάδας που έχουν ήδη υπογράψει: {names}",
        "empty_signature_warning": "Σχεδίασε πρώτα την υπογραφή σου.",
        "marked": "Η θέση της υπογραφής σημειώθηκε",
        "next": "Επόμενο",
        "no_signature_indicators_warning": "Υπόδειξε πού πρέπει να υπογραφεί το έγγραφο, κάνοντας κλικ στη σελίδα ή στις σελίδες.",
        "ok": "OK",
        "original": "Πρωτότυπο",
        "page": "σελίδα",
        "place_signature_subtitle": "Κάνε κλικ στη σελίδα ή στις σελίδες όπου χρειάζεται να υπογράψει ηλεκτρονικά ο πελάτης",
        "place_signature_title": "Σημείωσε πού θα υπογραφτεί",
        "read_and_sign": "Διάβασα και επιθυμώ να υπογράψω",
        "read_documents": "Διάβασε τα παρακάτω έγγραφα πριν τα υπογράψεις",
        "remove": "Αφαίρεση",
        "requesting_signage": "Αίτηση υπογραφής από",
        "save_error": "Παρουσιάστηκε σφάλμα κατά την αποθήκευση.",
        "sign": "Υπογραφή",
        "signatories_for_all_documents": "Ο αριθμός υπογραφόντων ισχύει για όλα τα έγγραφα. Αν τον αλλάξεις, θα αφαιρεθούν όλες οι υπογραφές και θα χρειαστεί να τις προσθέσεις ξανά.",
        "signatureNotPossible": "Οι ηλεκτρονικές υπογραφές δεν είναι διαθέσιμες για αυτόν τον τύπο αρχείου",
        "signatureNotPossibleSize": "Οι ηλεκτρονικές υπογραφές δεν είναι διαθέσιμες για αρχεία άνω των 40 MB",
        "signatures_pending_from_client": "Εκκρεμούν υπογραφές από την ομάδα της εταιρείας «{client_name}»",
        "signed": "Υπογράφηκε",
        "signed_progress": "Υπεγράφησαν: {already_signed_count} από {all_required_to_sign_count}",
        "specifyWhereToSign": "Σημείωσε πού θα υπογραφτεί",
        "team_member": "Μέλος ομάδας",
        "team_member_signature_warning": "Θα μπορείς να ζητήσεις υπογραφή από μέλη της ομάδας αφού ζητήσεις υπογραφή από πελάτες.",
        "thank_you_for_signing": "Ευχαριστούμε για την υπογραφή.",
        "toBeSigned": "Προς υπογραφή",
        "troubleSigningUpload": "Δυσκολεύεσαι να υπογράψεις; Ανέβασε ένα υπογεγραμμένο έγγραφο αντ' αυτού"
      }
    }
  }
}
